import { BaseDb } from "common/BaseDb"
import { DailySchemaWithId } from "components/daily/daily.schema"

class DailyDb extends BaseDb<DailySchemaWithId> {
    // no-op on web/base builds - offline sync only exists on the mobile (.mobile.ts) variant of this class,
    // resolved at bundle time for mobile-only call sites that import this module by its bare path
    async sync(_sessionId?: string): Promise<void> {
        return
    }

    async getOutstandingCount(): Promise<number> {
        return 0
    }
}

const dailyDb = new DailyDb("daily")
export default dailyDb
